<template>
  <div v-if="$store.getters.isLoggedIn" class="navbar-submenu" :class="{'navbar-submenu--open': isOpen}">
    <span class="navbar-button" @click="isOpen = !isOpen">
      <i class="fas fa-user"></i>
      {{ username }}
      <i v-if="isOpen" class="fas fa-arrow-up navbar-button-arrow-indicator"></i>
      <i v-else class="fas fa-arrow-down navbar-button-arrow-indicator"></i>
    </span>
    <span v-if="isOpen" class="navbar-submenu--menu">
      <router-link :to="'/profile/edit'" tag="span">
        <i class="fas fa-user-edit"></i>
        Editovat svůj profil
      </router-link>
      <span @click="logout()">
        <i class="fas fa-sign-out-alt"></i>
        Odhlásit se
      </span>
    </span>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'UserMenu',
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
        username() {
            return _.get(this.$store.getters.currentUser, 'username')
        },
    },
    methods: {
        async logout() {
            await this.$store.dispatch('currentUserLogout')
            this.$router.push('/')
            // TODO flash message po odhlaseni a presmerovani
        },
    },
}
</script>

<style scoped lang="scss">
@keyframes navbar-button-arrow-indicator--keyframes {
  0% {
    color: #708090;
  }
  20% {
    color: white;
  }
  40% {
    color: #708090;
  }
  100% {
    color: #708090;
  }
}

.navbar-submenu {
    display: flex;
    flex-direction: column;
    overflow: auto;
  &--menu {
    background-color: whitesmoke;
    color: var(--color-primary);
    padding: 2px 10px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-bottom: 1px solid var(--color-primary);
    border-right: 1px solid var(--color-primary);
    border-left: 1px solid var(--color-primary);
    display: flex;
    flex-direction: column;
    &>span {
      cursor: pointer;
      padding: 5px 0;
      &:hover {
        color: firebrick;
      }
    }
  }
  &--open {
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.5);
  }
}

.navbar-button {
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  &-arrow-indicator {
    color: #708090;
  }
  &:hover > .navbar-button-arrow-indicator {
    animation: navbar-button-arrow-indicator--keyframes 2s ease-out 0s infinite normal;
  }
}
</style>
